// ============================================================
// 📁 آدرس این فایل در پروژه (فایل جدید):
//    src/utils/pwa.ts
//
// برنامه‌ی قابل نصب (PWA): روی موبایل «افزودن به صفحه‌ی اصلی» و مثل یک اپ باز می‌شود.
// خودکار از Tracking.tsx فراخوانی می‌شود؛ جای دیگری لازم نیست.
// ============================================================
let done = false;
export function initPwa() {
  if (done || typeof document === "undefined") return;
  done = true;
  try {
    if (!document.querySelector('link[rel="manifest"][href="/pwa-manifest.json"]')) {
      const l = document.createElement("link"); l.rel = "manifest"; l.href = "/pwa-manifest.json"; document.head.appendChild(l);
    }
    if (!document.querySelector('meta[name="theme-color"]')) {
      const m = document.createElement("meta"); m.name = "theme-color"; m.content = "#0f172a"; document.head.appendChild(m);
    }
    if ("serviceWorker" in navigator && window.location.protocol === "https:") {
      window.addEventListener("load", () => { navigator.serviceWorker.register("/pwa-sw.js").catch(() => {}); });
      if (document.readyState === "complete") navigator.serviceWorker.register("/pwa-sw.js").catch(() => {});
    }
  } catch { /* بی‌صدا */ }
}
